/* eslint-disable import/no-unresolved */
/* eslint-disable react/prop-types */
import React from 'react';
import { Box, Typography, Link } from '@material-ui/core';
import { useHistory } from "react-router-dom";
import style from './style';

function ProducItemAtom({
    dealId, image, productName, minPrice, maxPrice, place
}) {
    const classes = style();
    const history = useHistory();
    // const getKey = () => {
    //     history.push(`/marketView/${dealId}`);
    // }
    return (
        // <Link className={classes.manageListStyle} onClick={getKey}>
        <div >
            <Box className={classes.imageWidth}>
                {image}
            </Box>
            <Box className={`${classes.contetnArrange}`}>
                <Box>
                    <Typography variant="body1">
                        {productName}
                    </Typography>
                    <Typography variant="body1">
                        {place} | Rs. {minPrice}-{maxPrice}
                    </Typography>
                </Box>
            </Box>
        </div>
        // </Link>
    );
}

export default ProducItemAtom;